import * as ca from './ca-ES.json';
import * as es from './es-ES.json';
import * as fr_BE from './fr-BE.json';
import * as fr from './fr-FR.json';
import * as nl_BE from './nl-BE.json';

export { fr, fr_BE, nl_BE, es, ca };
